import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type ClosedLocalDateRange} from 'web-app/util/graphql/api-types';

const domain = 'INVOICING_PROFILES/ATTENDANCE_SCHEDULES';

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: toggleDate} = createAction(`${domain}/TOGGLE_DATE`, (date: Date) => ({date}));

export const {action: loadPeriodsFromApi} = createAction(
    `${domain}/LOAD_PERIODS_FROM_API`,
    (periods: ClosedLocalDateRange[]) => ({periods}),
);

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, (institutionId: string) => ({institutionId}));

export const {action: dayMouseOver} = createAction(`${domain}/DAY_MOUSE_OVER`, (date: Date) => ({date}));

export const {action: activateCalendar} = createAction(`${domain}/ACTIVATE_CALENDAR`, () => ({}));

export const {action: deactivateCalendar} = createAction(`${domain}/DEACTIVATE_CALENDAR`, () => ({}));

export const {action: touchDate} = createAction(`${domain}/TOUCH_DATE`, (date: Date) => ({date}));

export const {action: toggleIncludeDeleted} = createAction(`${domain}/TOGGLE_INCLUDE_DELETED`, () => ({}));
